import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/InfluencerAnalyticsTwitterRefreshAvailability.graphql';
import { Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs } from '../../__generated__/globalTypes';

export const useInfluencerAnalyticsTwitterRefreshAvailabilityQuery = (
  options?: QueryHookOptions<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useInfluencerAnalyticsTwitterRefreshAvailabilityLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>
): QueryResult<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs> & {
  getInfluencerAnalyticsTwitterRefreshAvailability: LazyQueryExecFunction<
    Query,
    QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs
  >;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getInfluencerAnalyticsTwitterRefreshAvailability, result] = useLazyQuery<
    Query,
    QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs
  >(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getInfluencerAnalyticsTwitterRefreshAvailability, ...result };
};

export const useInfluencerAnalyticsTwitterRefreshAvailabilityPromiseQuery = () => {
  const client = useApolloClient();

  const getInfluencerAnalyticsTwitterRefreshAvailability = useCallback(
    (options?: Omit<QueryOptions<QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs, Query>, 'query'>) =>
      client.query<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getInfluencerAnalyticsTwitterRefreshAvailability };
};
// Suspense Query Hooks
export const useInfluencerAnalyticsTwitterRefreshAvailabilitySuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>
) => {
  const result = useSuspenseQuery<Query, QueryinfluencerAnalyticsTwitterRefreshAvailabilityArgs>(QUERY, {
    ...options
  });

  return result;
};
